import axios from "axios";

import { devMode } from "./base";
import { arrayToString, arrayObjToString, stypes } from "../components/common/common";

const baseDomain = `https://m-car${devMode ? "-dev" : ""}.mioto.vn`;

export function searchCSForList(filter) {
	let vType = "";
	if (filter.vehicleType && filter.vehicleType.length > 0) {
		vType = `&vType=${arrayToString(filter.vehicleType)}`;
	}
	const vMake =
		filter.vehicleMake && filter.vehicleMake !== "" && filter.vehicleMake > 0 ? `&vMake=${filter.vehicleMake}` : "";
	let vModel = "";
	if (filter.vehicleModel && filter.vehicleModel.length > 0) {
		vModel = `&vModel=${filter.vehicleModel.join(";")}`;
	} 

	// const skuGroupId = `&skuGroupId=${filter.skuGroupId}`;


	// const fromCarId = filter.fromCarId && filter.fromCarId !== "" ? `&fromCarId=${filter.fromCarId}` : "";

	const discount = filter.discount ? `&discount=true` : "";
	const transmission = filter.transmission > 0 ? `&transmission=${filter.transmission}` : "";
	const fuel = filter.fuel > 0 ? `&fuel=${filter.fuel}` : "";

	return axios({
		withCredentials: true,
		method: "POST",
		url: `${baseDomain}/subcription/search?lat=${filter.lat}&lon=${
			filter.lng
		}&st=${filter.startDate.valueOf()}&et=${filter.endDate.valueOf()}&sort=${
			filter.sort
		}${vType}${vMake}${vModel}&pos=${filter.pos}${discount}${transmission}${fuel}`,
	});
}

export function getCS(ex) {
	const pLatD = ex.lat !== 0 ? `&lat=${ex.lat}` : "";
	const pLonD = ex.lon !== 0 ? `&lon=${ex.lon}` : "";

	return axios({
		withCredentials: true,
		method: "GET",
		url: `${baseDomain}/subcription/detail?skuGroupId=${
			ex.skuGroupId
		}&st=${ex.st.valueOf()}&et=${ex.et.valueOf()}${pLatD}${pLonD}`,
	});
}

export function bookCS(trip) {

	const skuId=`skuId=${trip.skuId}`
	const dateFrom = `&dateFrom=${trip.dateFrom}`;
	const dateTo = `&dateTo=${trip.dateTo}`;
	const price = `&price=${trip.price}`;
	const yearFrom = trip.yearFrom ? `&yearFrom=${trip.yearFrom}` : '';
	const yearTo = trip.yearTo ? `&yearTo=${trip.yearTo}` : '';


    return axios({
        method: "POST",
        withCredentials: true,
        url: `${baseDomain}/subcription/book?${skuId}${dateFrom}${dateTo}${price}${yearFrom}${yearTo}`
    })
}


export function getMyCSTrips(pos) {

    return axios({
        method: "GET",
        withCredentials: true,
        url: `${baseDomain}/subcription/my-trips?pos=${pos}`
    })
}
